import React, { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { useTheme } from '@material-ui/core/styles';
import useMediaQuery from '@material-ui/core/useMediaQuery';
import Link from 'next/link';
import Grid from '@material-ui/core/Grid';
import Button from '@material-ui/core/Button';

import { setFooter } from 'features/utilsSlice';
import useScrollToTop from 'hooks/useScrollToTop';
import useAuthRedirect from 'hooks/useAuthRedirect';
import DocumentHead from 'components/DocumentHead';
import AnimateList from 'components/animations/AnimateList';
import AnimateListItem from 'components/animations/AnimateListItem';
import styles from 'styles/components/auth/SignUp.module.scss';

const minHeight = { position: 'relative' };

const SignUp = () => {
  useAuthRedirect();
  useScrollToTop();
  const dispatch = useDispatch();
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('xs'));

  useEffect(() => {
    if (isMobile) {
      dispatch(setFooter(false));
    }

    return () => dispatch(setFooter(true));
  }, [dispatch, isMobile]);

  return (
    <AnimateList style={minHeight}>
      <Grid container className={styles.signUp} justifyContent="center">
        <DocumentHead>
          <title>Sign Up | GigSocial</title>
        </DocumentHead>

        <Grid item xs={11} sm={6} md={4} lg={4} xl={3}>
          <h1>Who are you?</h1>

          <AnimateListItem className={styles.type}>
            <Link href="/sign-up/influencer" passHref>
              <Button variant="contained" color="primary">
                Influencer
              </Button>
            </Link>

            <span>Get started making money</span>
          </AnimateListItem>

          <AnimateListItem className={styles.type}>
            <Link href="/sign-up/advertiser" passHref>
              <Button variant="contained" color="primary">
                Company / Individual Buyer
              </Button>
            </Link>

            <span>List gigs, match with influencers, buy shoutouts</span>
          </AnimateListItem>

          <AnimateListItem className={styles.type}>
            <Link href="/sign-up/athlete" passHref>
              <Button variant="contained" color="primary">
                Athlete
              </Button>
            </Link>

            <span>Sell name, image, likeness and event appearances</span>
          </AnimateListItem>
        </Grid>
      </Grid>
    </AnimateList>
  );
};

export default SignUp;
